import React from 'react';

/* ── Marque Palestre ────────────────────────────────────────────────────────
   Le PÉRISTYLE : la cour carrée ceinte de portiques de la palaistra grecque
   (παλαίστρα, de palē « la lutte »), vue d'en haut — l'enceinte, la cour au
   centre, et l'entrée ouverte en bas. C'est ce dernier détail qui distingue la
   marque d'un cadre générique : il dit « bâtiment vu en plan ».

   Registre grec (l'école d'entraînement), volontairement PAS romain
   (le trident du rétiaire, l'arène) — décision Olivier 2026-08-15.

   Aucune couleur en dur : le tracé est en `currentColor`, la couleur vient donc
   du contexte (token de charte appliqué par le parent). */

const VIEWBOX = '0 0 64 64';

/* Tracé unique, réutilisé partout — ne pas le dupliquer ailleurs. */
function Mark({ strokeWidth }) {
  return (
    <g fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round">
      {/* Enceinte, interrompue en bas au centre = l'entrée. */}
      <path d="M25 52 h-7 a6 6 0 0 1 -6 -6 v-28 a6 6 0 0 1 6 -6 h28 a6 6 0 0 1 6 6 v28 a6 6 0 0 1 -6 6 h-7" />
      {/* La cour. */}
      <rect x="24" y="24" width="16" height="16" rx="3" />
    </g>
  );
}

/**
 * Marque Palestre.
 *
 * @param {number} size   Côté du carré, en pixels (défaut 28).
 * @param {string} title  Texte accessible ; absent = marque décorative.
 *
 * LE TRAIT S'EST AFFINÉ le 18.09.2026, et la marque a grossi d'autant dans la
 * barre : à 5 px d'épaisseur sur un plan de 64, le péristyle se lisait comme un
 * bloc et sa cour se refermait. Il s'épaissit toujours sous 24 px, où un trait
 * constant se dilue et où l'entrée n'est plus lisible, mais moins fort.
 */
export default function Logo({ size = 28, title, className, ...rest }) {
  const strokeWidth = size < 20 ? 5.2 : size < 24 ? 4.2 : 3.5;
  return (
    <svg
      viewBox={VIEWBOX}
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      {...rest}
    >
      <Mark strokeWidth={strokeWidth} />
    </svg>
  );
}
